import { render } from "./AdminDashboard.vue?vue&type=template&id=ec880468&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ec880468"

export default script